import { defaultLocale } from "../../i18nConfig";

export function useCurrentLocale(): string {
  return defaultLocale;
}
